import { Component, ElementRef, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import * as MailboxActions from '../../store/actions/mailbox.actions';
import { ApplicationState } from '../../../store/reducers';
import { initialState } from '../../store/reducers/mailboxes.reducer';
import { takeUntil } from 'rxjs/operators';
import { OnDestroyNewHookDirective } from '../../../shared/hooks';

@Component({
  selector: 'mprd-px-mymail-app',
  templateUrl: 'px-mymail-app.component.html',
})
export class PxMyMailAppComponent
  extends OnDestroyNewHookDirective
  implements OnInit
{
  loading = true;

  constructor(
    private translationService: TranslationService,
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
  ) {
    super();
  }

  ngOnInit() {
    this.translationService.parse(this.elementRef.nativeElement);
    this.store.dispatch(new MailboxActions.LoadAction());
    this.store
      .pipe(takeUntil(this.unsub$))
      .subscribe((state: ApplicationState) => {
        if (state.mailboxes !== initialState) {
          this.loading = false;
        }
      });

    this.scrollToTop();
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#myMail');
    });
  }
}
